export default __webpack_public_path__ + "static/media/Additional_Notes.435353cb.svg";